// Ambiente development — usado pelo pipeline de deploy no Firebase
// Para desenvolvimento local, o ng serve usa environment.ts (localhost:3000)
export const environment = {
  production: false,
  apiUrl: 'https://dev-api-smartvision.vitrineretail.com',
};
